import { getFrontpageImages } from "#templates/pages/dialog.js";
import { createGuid, contentMeta, isMobile, truncateWithElipsis } from "#scripts/general_functions";
import cardslist, { carditem } from "#templates/modules/cardlisting_template";
import language from "#scripts/translation";
import { getImageByContentId } from "#scripts/images";

export const rekPredictions = (maxItems, moduleTitle, mode, _options) => {
	let tmpHtml = "";
	const moduleGuid = createGuid();

	if (typeof window !== "undefined" && window.__rekai) {
		// mode = ["pill", "pills", "pille", "piller"].includes(mode) ? "pill" :
		// 	["card", "cards", "kort"].includes(mode) ? "card" :
		// 		["faq", "qna", "qa"].includes(mode) ? "faq" : mode;
		mode = normalizeMode(mode);

		const advanced_mockdata = false; //mode === "faq" ? true : false;
		const entitytype = mode === "faq" ? "rekai-qna" : "";

		if (_options !== "") {
			const jsonString = _options.replace(/;/g, ':') // Replace semicolons with colons
				.replace(/(\w+)(?=\s*:)/g, '"$1"') // Add double quotes around keys
				.replace(/:\s*([^",}\s]+)/g, ': "$1"') // Add double quotes around string values
			// Parse the JSON
			_options = JSON.parse(jsonString);
		}

		const options = { overwrite: { addcontent: true, nrofhits: maxItems, entitytype: entitytype, advanced_mockdata: advanced_mockdata } };
		if (_options !== "") {
			options.overwrite = {
				...options.overwrite,
				..._options
			};
		}

		// Call the predict method on the __rekai object
		window.__rekai.predict(options, (data) => {
			const predictions = data.predictions;
			switch (mode) {
				case "pill": {
					tmpHtml = "<ul>";
					for (const prediction of predictions) {
						tmpHtml = `${tmpHtml}<li><a href="${prediction.url}">${prediction.title}</a></li>`;
					}
					tmpHtml = `${tmpHtml}</ul>`;
					document.getElementById(moduleGuid).insertAdjacentHTML("beforeend", tmpHtml);
					break;
				}
				case "card": {
					const cards = [];
					const moduleCardColor = "";
					for (const prediction of predictions) {
						const cardGuid = createGuid();
						const image = `<div class="card__image_container"><img src='//res.cloudinary.com/ssp/image/fetch/c_fill,ar_16:9/c_limit,w_1140/${prediction.imgurl}' id='card__${cardGuid}' class="card__image" desc="" alt=""></div>`;
						cards.push({
							item: carditem({
								link: prediction.url,
								image: image,
								title: prediction.title,
								intro: truncateWithElipsis(prediction?.ingress, 170),
								tag: "",
								color: moduleCardColor,
							}),
						});
					}

					if (cards.length > 0) {
						document.getElementById(`cards_${moduleGuid}`).insertAdjacentHTML("beforeend", cards.map((obj) => obj.item).join(""));
					} else {
						document.getElementById(`module__cards_${moduleGuid}`).style.display = "none";
					}

					break;
				}
				case "faq": {
					// advanced_mockdata: true
					for (const prediction of predictions) {
						const id = prediction.id;
						tmpHtml = `${tmpHtml}<div class="accordian" id="box-${id}">
												<h2 class="accordian-title" id="accordian-boxheader-${id}">
													<button class="accordian-titlebutton" type="button" data-toggle="collapse" aria-expanded="false" data-target="#accordian-boxcontent-${id}" data-parent="#box-${id}" aria-controls="accordian-boxcontent-${id}">${prediction.question}</button>
												</h2>
												<div class="accordian-content" 
													id="accordian-boxcontent-${id}" data-scrolltoaction="openaccordian" aria-labelledby="accordian-boxheader-${id}" data-parent="#box-${id}">
													<p>${prediction.answer}</p>
												</div>
											</div>`;
					}
					document.getElementById(moduleGuid).insertAdjacentHTML("beforeend", tmpHtml);
					break;
				}
				case "hero": {
					tmpHtml = "<ul>";
					for (const prediction of predictions) {
						tmpHtml = `${tmpHtml}<li><a href="${prediction.url}">${prediction.title}</a></li>`;
					}
					tmpHtml = `${tmpHtml}</ul>`;
					document.getElementById(moduleGuid).insertAdjacentHTML("beforeend", tmpHtml);
					break;
				}
			}
		});

	}

	let template = "";
	switch (mode) {
		case "pill": {
			template = `<div>
                    <div class="rek-title ${mode}">${moduleTitle}</div>
                    <div id="${moduleGuid}" class="rek-predictions ${mode}">${tmpHtml}</div>
                  </div>`;
			break;
		}
		case "card": {
			template = `<section id="module__cards_${moduleGuid}" class="module__cards card__design__1">
										<div class="rek-title ${mode}">${moduleTitle}</div>
                    <div class="rek-predictions ${mode}"><div class="cards" id="cards_${moduleGuid}"></div></div>
                  </section>`;
			break;
		}
		case "faq": {
			template = `<div>
                    <div class="rek-title ${mode}">${moduleTitle}</div>
                    <div id="${moduleGuid}" class="rek-${mode}">${tmpHtml}</div>
                  </div>`;
			break;
		}
		case "hero": {
			getFrontpageImages(1, 0).then((imageList) => {
				for (const item of imageList.listOfContent) {
					const meta = contentMeta(item);
					getImageByContentId(meta.imageContentId, (img) => {
						const viewMode = isMobile() ? "_mobile" : "";
						const elmDialog = document.querySelector(".chatbot-search--container");
						const maskImage = window.serverdata.configMeta.aim?.frontImageMask ? `url(${window.serverdata.configMeta.aim?.frontImageMask}), ` : "";
						const maskPosition = window.serverdata.configMeta.aim?.frontImageMask
							? `calc(var(--dialog__cb__image_horizontal-position${viewMode}, center) - 1px) var(--dialog__cb__image_vertical-position${viewMode}, center), `
							: "";

						// if (!isMobile()) {
						let url = img.url || window.serverdata.configMeta.aim.frontImage;
						if (url.includes("preview.sdl.no")) {
							url = url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
						}

						const bgImage = `https://res.cloudinary.com/ssp/image/fetch/g_auto,c_fill,f_auto/${url}`;
						elmDialog.dataset.background = bgImage;
						elmDialog.style.backgroundImage = `${maskImage}url('${bgImage}')`;

						elmDialog.style.backgroundPosition = `${maskPosition}var(--dialog__cb__image_horizontal-position${viewMode}, center) var(--dialog__cb__image_vertical-position${viewMode}, center)`;
						elmDialog.style.backgroundRepeat = "no-repeat";

						// // add image to dialog__overlay__graph-right div
						const elmDialogImgDiv = document.querySelector(".dialog__overlay__graph-right");
						if (elmDialogImgDiv !== null) {
							elmDialogImgDiv.style.backgroundImage = `${maskImage}url('${bgImage}')`;
							elmDialogImgDiv.querySelector("img").src = bgImage;
						}
						// }
					});
				}
			});
			template = `<div class="chatbot-search chatbot-search--container hero" data-background="">
                    <div class="container">
                      <div class="row">
                        <div class="header__search col-lg-8" role="search">
                          <div>Hva leter du etter i dag?</div>
                          <div class="header__search__container" style="margin-left: 0px;max-width: 560px;">
                              <input id="rek-search-input" type="search" name="searchsite" value="" autocomplete="off" placeholder="Søk her" class="input-control header__search__input" aria-label="søk">
                              <button class="header__button__dosearch" aria-label="søk">
                                  <span class="material-icons-outlined notranslate header__icon"></span>
                              </button>
                          </div>
                      </div>
                      </div>
                      <div class="row">
                        <div>
                          <div class="rek-title ${mode} col-lg-8">${moduleTitle}</div>
                          <div id="${moduleGuid}" class="rek-predictions ${mode} col-lg-8" id="rek-1">${tmpHtml}</div>
                        </div>
                      </div>
                      <img src="">
                    </div>
                  </div>
									<style>
										#rek-search-input_autocomplete-list {
											position: absolute;
											background-color: #fff;
											padding: 15px;
											font-size: 1rem;
											font-weight: 400;
											z-index: 1;
											top: 121px;
											border-radius: 0 0 6px 6px;
											display: flex;
											flex-direction: column;
											min-width: 548px;
											margin-left: 6px;
											border-top: thin solid #00000030;
											box-shadow: 0px 5px 10px -3px;
											gap: 3px;
										}
										.autocomplete-items span:hover {
											background-color: #efefef;
											margin: -5px -15px;
											padding: 5px 15px;
											cursor: pointer;
										}
										.autocomplete-active {
											background-color: var(--dialog__cb__search-container_bg-color, #cecece);
											color: #1e1e1e;
											margin: -5px -15px;
											padding: 5px 15px;
										}
									</style>
									`;
			document.getElementById("chatbot__container").insertAdjacentHTML("beforeend", template);

			document.getElementById("chatbot__container").addEventListener("keyup", (event) => {
				if (event.target && event.target.id === "rek-search-input" && event.target.value.length > 2) {
					event.preventDefault();
					if (event.key === "ArrowDown" || event.key === "ArrowUp") return;
					const existingList = document.getElementById(`${event.target.id}_autocomplete-list`);
					if (event.key === "Enter" && !existingList) {
						return;
					}

					const options = { addcontent: true };
					window.__rekai.predictAutocomplete(event.target.value, options, showAutocomplete);
				}
			});

			template = "";
			break;
		}
	}
	return template;
};

const addKeyboardNavigation = (input, list) => {
	let currentFocus = -1;

	input.addEventListener("keydown", (e) => {
		const items = list.getElementsByTagName("span");
		if (e.key === "ArrowDown") {
			// Down arrow
			e.preventDefault();
			currentFocus++;
			addActive(items);
		} else if (e.key === "ArrowUp") {
			// Up arrow
			e.preventDefault();
			currentFocus--;
			addActive(items);
		} else if (e.key === "Enter") {
			// Enter
			// e.preventDefault();
			if (currentFocus > -1) {
				if (items) {
					const existingList = document.getElementById(`${input.id}_autocomplete-list`);
					input.value = items[currentFocus].innerText;
					const input2 = document.getElementsByName("searchsite");
					input2.value = items[currentFocus].innerText;
					if (existingList !== null) {
						input.closest(".header__search").removeChild(existingList);
					}
					currentFocus = -1;
				}
			}
		}
	});

	document.getElementById("rek-search-input_autocomplete-list").addEventListener("click", (event) => {
		if (event.target && event.target.tagName === "SPAN") {
			event.preventDefault();
			if (event.target.innerText !== "") {
				// input.value = event.target.innerText;
				const input2 = document.getElementsByName("searchsite");
				for (const element of input2) {
					element.value = event.target.innerText;
				}
				const existingList = document.getElementById(`${input.id}_autocomplete-list`);
				if (existingList !== null) {
					input.closest(".header__search").removeChild(existingList);
				}
				currentFocus = -1;
				const enterEvent = new KeyboardEvent("keydown", {
					bubbles: false,
					cancelable: true,
					key: "Enter",
					code: "Enter",
					keyCode: 13,
					which: 13,
				});
				input.dispatchEvent(enterEvent);
			}
		}
	});

	function addActive (items) {
		if (!items) return false;
		removeActive(items);
		if (currentFocus >= items.length) currentFocus = 0;
		if (currentFocus < 0) currentFocus = items.length - 1;
		items[currentFocus].classList.add("autocomplete-active");
	}

	function removeActive (items) {
		for (const item of items) {
			item.classList.remove("autocomplete-active");
		}
	}
};

const showAutocomplete = (data) => {
	const input = document.getElementById("rek-search-input");

	// Remove any existing autocomplete list
	const existingList = document.getElementById(`${input.id}_autocomplete-list`);
	if (existingList) {
		input.closest(".header__search").removeChild(existingList);
	}
	if (data.length === 0) {
		return;
	}

	const a = document.createElement("DIV");
	a.setAttribute("id", `${input.id}_autocomplete-list`);
	a.setAttribute("class", "autocomplete-items");

	for (const suggestion of data) {
		if (suggestion.title) {
			const b = document.createElement("span");
			b.innerHTML = highlightMatches(suggestion.title, input.value);
			a.appendChild(b);
		}
	}

	input.closest(".header__search").appendChild(a);
	addKeyboardNavigation(input, a);
};

const highlightMatches = (str, pattern) => {
	const regex = new RegExp(`(${pattern})`, "gi");
	return str.replace(regex, "<strong>$1</strong>");
};

const normalizeMode = (mode) => {
	const modeMap = {
		pill: ["pill", "pills", "pille", "piller"],
		card: ["card", "cards", "kort"],
		faq: ["faq", "qna", "qa"]
	};

	for (const [key, values] of Object.entries(modeMap)) {
		if (values.includes(mode)) return key;
	}
	return mode;
};
